
// import React, { useState, useRef, useEffect } from 'react';
// import { Box, Typography, Card, CardContent, useTheme, Stack, Divider, CircularProgress } from '@mui/material';

// // --- Interfaces and Helper Functions ---
// interface RegionDetail {
//   cost: string | number;
//   region: string;
// }

// interface CostByRegionProps {
//   costByRegionData?: RegionDetail[] | null;
//   isLoading: boolean;
// }

// interface HoverInfo {
//   data: any;
//   position: { top: number; left: number };
// }

// // A new, simpler interface for the data points we'll render
// interface ProcessedRegion {
//   costNum: number;
//   region: string;
//   pos: { x: string; y: string };
//   color: string;
//   labelOffset: number; 
// }

// // Maps region names to their pixel coordinates on the map
// const regionToPositionMap: { [key: string]: { x: string; y: string } } = {
//     "us-central1": { x: '24%', y: '35%' }, "us-east1": { x: '28%', y: '25%' }, "us-east4": { x: '33%', y: '20%' },
//     "us-west1": { x: '13%', y: '38%' }, "us-west2": { x: '12%', y: '42%' }, "us-west3": { x: '18%', y: '45%' },
//     "us-west4": { x: '15%', y: '48%' }, "northamerica-northeast1": { x: '40%', y: '20%' }, "northamerica-northeast2": { x: '42%', y: '15%' },
//     "southamerica-east1": { x: '40%', y: '75%' }, "europe-west1": { x: '50%', y: '30%' }, "europe-west2": { x: '48%', y: '25%' },
//     "europe-west3": { x: '55%', y: '28%' }, "europe-west4": { x: '52%', y: '32%' }, "europe-west6": { x: '45%', y: '28%' },
//     "europe-central2": { x: '58%', y: '35%' }, "europe-north1": { x: '60%', y: '20%' }, "asia-east1": { x: '80%', y: '40%' },
//     "asia-east2": { x: '82%', y: '42%' }, "asia-northeast1": { x: '85%', y: '30%' }, "asia-northeast2": { x: '88%', y: '32%' },
//     "asia-northeast3": { x: '90%', y: '35%' }, "asia-south1": { x: '72%', y: '49%' }, "asia-south2": { x: '76%', y: '52%' },
//     "asia-southeast1": { x: '85%', y: '55%' }, "asia-southeast2": { x: '88%', y: '58%' }, "australia-southeast1": { x: '86%', y: '77%' },
//     "australia-southeast2": { x: '89%', y: '80%' }, "me-central1": { x: '60%', y: '45%' }, "me-west1": { x: '58%', y: '48%' },
//     "africa-south1": { x: '55%', y: '80%' },
// };

// const formatRangeValue = (value: number): string => {
//   if (value < 0) value = 0;
//   if (value >= 1000000) return `$${(value / 1000000).toFixed(1).replace('.0', '')}M`;
//   if (value >= 1000) return `$${Math.floor(value / 1000)}k`;
//   return `$${Math.round(value)}`;
// };

// const formatCurrency = (amount: string | number | null | undefined): string => {
//   if (amount === null || amount === undefined) return '$0';
//   const numericAmount = parseFloat(String(amount).replace(/[^0-9.-]+/g, ""));
//   if (isNaN(numericAmount)) return '$0';
//   return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(numericAmount);
// };

// const hexToRgba = (hex: string, alpha: number): string => {
//     if (!hex.startsWith('#')) return `rgba(232, 212, 35, ${alpha})`; // Fallback for non-hex
//     const r = parseInt(hex.slice(1, 3), 16);
//     const g = parseInt(hex.slice(3, 5), 16);
//     const b = parseInt(hex.slice(5, 7), 16);
//     return `rgba(${r}, ${g}, ${b}, ${alpha})`;
// };

// // --- MODIFICATION: Updated HexagonMarker for flat-top orientation ---
// const HexagonMarker = ({ color }: { color: string }) => {
//   // This new path creates a hexagon with a flat top and bottom
//   const hexagonPath = "25% 0%, 75% 0%, 100% 50%, 75% 100%, 25% 100%, 0% 50%";
//   const size = 12; // Size of the central hexagon
//   const surroundingSize = size * 0.95;
  
//   // Adjusted spacing for a flat-topped hexagonal grid
//   const spacingX = size * 0.88; 
//   const spacingY = size * 0.76;

//   // Positions for the 6 surrounding hexagons, adjusted for flat-top tiling
//   const positions = [
//     { x: spacingX, y: 0 },
//     { x: spacingX / 2, y: -spacingY },
//     { x: -spacingX / 2, y: -spacingY },
//     { x: -spacingX, y: 0 },
//     { x: -spacingX / 2, y: spacingY },
//     { x: spacingX / 2, y: spacingY },
//   ];

//   return (
//     <Box sx={{ 
//         position: 'relative', 
        
//         width: size * 3, 
//         height: size * 3, 
//         transform: 'translate(-50%, -50%)' // Removed rotation
//     }}>
//       {/* Surrounding Hexagons */}
//       {positions.map((pos, index) => (
//         <Box
//           key={index}
//           sx={{
//             position: 'absolute',
//             top: `calc(50% + ${pos.y}px)`,
//             left: `calc(50% + ${pos.x}px)`,
//             width: surroundingSize,
//             height: surroundingSize,
//             bgcolor: hexToRgba(color, 0.3),
//             clipPath: `polygon(${hexagonPath})`,
//             transform: 'translate(-50%, -50%)',
//           }}
//         />
//       ))}
//       {/* Central Hexagon */}
//       <Box
//         sx={{
//           position: 'absolute',
//           top: '50%',
//           left: '50%',
//           width: size,
//           height: size,
//           bgcolor: color,
//           clipPath: `polygon(${hexagonPath})`,
//           transform: 'translate(-50%, -50%)',
//         }}
//       />
//     </Box>
//   );
// };


// const CostByRegion: React.FC<CostByRegionProps> = ({ costByRegionData, isLoading }) => {
//   const theme = useTheme();
//   const [hoverInfo, setHoverInfo] = useState<HoverInfo | null>(null);
//   const cardRef = useRef<HTMLDivElement>(null);
//   const [costRanges, setCostRanges] = useState({ low: '', medium: '', high: '' });
//   const [processedRegions, setProcessedRegions] = useState<ProcessedRegion[]>([]);

//   useEffect(() => {
//     if (isLoading || !costByRegionData) {
//       setProcessedRegions([]);
//       return;
//     }
    
//     const validCosts = costByRegionData
//       .map(d => parseFloat(String(d.cost).replace(/[^0-9.-]+/g, "")))
//       .filter(c => !isNaN(c) && c >= 1)
//       .sort((a, b) => a - b);

//     if (validCosts.length === 0) {
//       setProcessedRegions([]);
//       setCostRanges({ low: '', medium: '', high: '' });
//       return;
//     }
    
//     const maxCost = validCosts[validCosts.length - 1];

//     // --- NEW: "Nice Number" Distribution Logic ---

//     // 1. Helper function to round a number to the nearest 50.
//     const roundToNearest50 = (num: number) => Math.round(num / 50) * 50;

//     // 2. Calculate the boundaries by splitting the range and then rounding.
//     const boundary1 = roundToNearest50(maxCost / 3);
//     const boundary2 = roundToNearest50((2 * maxCost) / 3);

//     // 3. Round the max cost *up* to the nearest 50 for a clean final range.
//     const niceMaxEnd = Math.ceil(maxCost / 50) * 50;
    
//     // 4. Set the final legend strings with the "nice" numbers.
//     setCostRanges({
//         low: `Cost (${formatCurrency(0)} - ${formatCurrency(boundary1 - 1)})`,
//         medium: `Cost (${formatCurrency(boundary1)} - ${formatCurrency(boundary2 - 1)})`,
//         high: `Cost (${formatCurrency(boundary2)} - ${formatCurrency(niceMaxEnd)})`,
//     });

//     // The 'tiers' object now uses these same "nice" boundaries
//     // to ensure the map markers' colors match the legend perfectly.
//     const tiers = { boundary1, boundary2 };

//     const getMarkerColor = (cost: number): string => {
//         if (cost >= tiers.boundary2) return '#DC2626'; // High
//         if (cost >= tiers.boundary1) return '#E8D423'; // Medium
//         return '#16A34A'; // Low
//     };
    
//     // --- The rest of the layout logic remains the same ---
//     const regionsWithCost = costByRegionData
//         .map(d => ({ ...d, costNum: parseFloat(String(d.cost).replace(/[^0-9.-]+/g, ""))}))
//         .filter(d => !isNaN(d.costNum) && d.costNum >= 1);

//     const sortedForLayout = regionsWithCost
//         .map(d => ({ ...d, pos: regionToPositionMap[d.region] || { x: '50%', y: '50%' } }))
//         .sort((a,b) => parseFloat(a.pos.x) - parseFloat(b.pos.x));

//     let lastX = -100;
//     let lastY = -100;
//     let currentOffset = 0;

//     const finalRegions: ProcessedRegion[] = sortedForLayout.map(region => {
//       const xPos = parseFloat(region.pos.x);
//       const yPos = parseFloat(region.pos.y);

//       if (Math.abs(xPos - lastX) < 5 && Math.abs(yPos - lastY) < 8) {
//         currentOffset += 40; 
//       } else {
//         currentOffset = 0; 
//       }
//       lastX = xPos;
//       lastY = yPos;
      
//       return {
//           ...region,
//           labelOffset: currentOffset,
//           color: getMarkerColor(region.costNum),
//       };
//     });
//     setProcessedRegions(finalRegions);

//   }, [costByRegionData, isLoading]);


//   if (isLoading) {
//     return ( <Card elevation={0} sx={{ backgroundColor: theme.palette.background.paper, borderRadius: '10px', p: { xs: 2, sm: 3, md: 4 }, width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px' }}> <CircularProgress /> </Card> );
//   }

//   const handleMouseEnter = (e: React.MouseEvent, region: any) => {
//     const cardBox = cardRef.current?.getBoundingClientRect();
//     if (!cardBox) return;
//     setHoverInfo({ data: region, position: { top: e.clientY - cardBox.top, left: e.clientX - cardBox.left } });
//   };
//   const handleMouseLeave = () => setHoverInfo(null);


// return (
//     <Card ref={cardRef} elevation={0} sx={{ position: 'relative', backgroundColor: theme.palette.background.paper, borderRadius: '16px', p: { xs: 2, sm: 3, md: 4 }, width: '100%' }}>
//       <CardContent sx={{ p: 0, '&:last-child': { pb: 0 } }}>
//         <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
//           <Typography variant="h6" component="h2" sx={{ fontWeight: 600, fontSize: '16px' }}>Cost By Region</Typography>
//           <Stack direction="row" spacing={2} alignItems="center">
//             {costRanges.low && <Stack direction="row" alignItems="center" spacing={1}><Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: '#16A34A' }} /><Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.75rem' }}>{costRanges.low}</Typography></Stack>}
//             {costRanges.medium && <Stack direction="row" alignItems="center" spacing={1}><Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: '#E8D423' }} /><Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.75rem' }}>{costRanges.medium}</Typography></Stack>}
//             {costRanges.high && <Stack direction="row" alignItems="center" spacing={1}><Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: '#DC2626' }} /><Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.75rem' }}>{costRanges.high}</Typography></Stack>}
//           </Stack>
//         </Box>
//         <Box sx={{ 
//           position: 'relative', 
//           width: '100%', 
//           aspectRatio: '860 / 490',
//           backgroundColor: '#FFFFFF', 
//           borderRadius: '8px', 
//           backgroundImage: `url(/world_map.svg)`, 
//           backgroundSize: 'contain', 
//           backgroundPosition: 'center', 
//           backgroundRepeat: 'no-repeat',
//           mx: 'auto'
//         }}>
//           {processedRegions.map((region, i) => (
//             <Box
//               key={`${region.region}-${i}`}
//               onMouseEnter={(e) => handleMouseEnter(e, region)}
//               onMouseLeave={handleMouseLeave}
//               sx={{
//                 position: 'absolute',
//                 top: region.pos.y,
//                 left: region.pos.x,
//                 width: '1px',
//                 height: '1px',
//                 cursor: 'pointer',
//                 zIndex: region.labelOffset > 0 ? 10 : 5, 
//               }}
//             >
//               {/* The Label */}
//               <Box
//                 sx={{
//                   position: 'absolute',
//                   bottom: `${12 + 25 + region.labelOffset}px`,
//                   left: '50%',
//                   transform: 'translateX(-50%)',
//                   bgcolor: 'rgba(255, 255, 255, 0.9)',
//                   backdropFilter: 'blur(2px)',
//                   p: '4px 8px',
//                   borderRadius: '6px',
//                   boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
//                 }}
//               >
//                 <Typography sx={{ fontFamily: 'Inter', fontSize: '12px', fontWeight: 'bold', color: 'text.primary', whiteSpace: 'nowrap' }}>
//                   {formatCurrency(region.costNum)}
//                 </Typography>
//               </Box>
//               {/* The Line */}
//               <Box
//                 sx={{
//                   position: 'absolute',
//                   bottom: '12px', // Adjusted for hexagon size
//                   left: '50%',
//                   transform: 'translateX(-50%)',
//                   width: '1.5px',
//                   height: `${25 + region.labelOffset}px`,
//                   bgcolor: hexToRgba(region.color, 0.6),
//                 }}
//               />
//               <Box sx={{position: 'absolute', top: 0, left: 0}}>
//                  <HexagonMarker color={region.color} />
//               </Box>
//             </Box>
//           ))}
//         </Box>
//       </CardContent>
//       {hoverInfo && (
//         <Box sx={{ position: 'absolute', top: hoverInfo.position.top, left: hoverInfo.position.left, transform: 'translate(15px, 15px)', minWidth: '180px', bgcolor: 'background.paper', borderRadius: '8px', p: 2, border: `1px solid ${theme.palette.divider}`, boxShadow: theme.shadows[4], pointerEvents: 'none', zIndex: 20 }}>
//           <Typography variant="body2" sx={{ fontWeight: 'bold', mb: 1, color: 'text.secondary' }}>{hoverInfo.data.region}</Typography>
//           <Divider sx={{ mb: 1 }} />
//           <Box display="flex" justifyContent="space-between" mb={0.5}>
//             <Typography variant="body2" color="text.secondary">Total Cost</Typography>
//             <Typography variant="body2" sx={{ fontWeight: 'bold' }}>{formatCurrency(hoverInfo.data.costNum)}</Typography>
//           </Box>
//         </Box>
//       )}
//     </Card>
//   );
// };
// export default CostByRegion;


// import React, { useState, useRef, useEffect } from 'react';
// import { Box, Typography, Card, CardContent, useTheme, Stack, Divider, CircularProgress } from '@mui/material';

// // --- Interfaces and Helper Functions ---
// interface RegionDetail {
//   cost: string | number;
//   region: string;
// }

// interface CostByRegionProps {
//   costByRegionData?: RegionDetail[] | null;
//   isLoading: boolean;
// }

// interface HoverInfo {
//   data: any;
//   position: { top: number; left: number };
// }

// // A new, simpler interface for the data points we'll render
// interface ProcessedRegion {
//   costNum: number;
//   region: string;
//   pos: { x: string; y: string };
//   color: string;
//   labelOffset: number; 
// }

// // Maps region names to their pixel coordinates on the map
// const regionToPositionMap: { [key: string]: { x: string; y: string } } = {
//     "us-central1": { x: '24%', y: '35%' }, "us-east1": { x: '28%', y: '25%' }, "us-east4": { x: '33%', y: '20%' },
//     "us-west1": { x: '13%', y: '38%' }, "us-west2": { x: '12%', y: '42%' }, "us-west3": { x: '18%', y: '45%' },
//     "us-west4": { x: '15%', y: '48%' }, "northamerica-northeast1": { x: '40%', y: '20%' }, "northamerica-northeast2": { x: '42%', y: '15%' },
//     "southamerica-east1": { x: '40%', y: '75%' }, "europe-west1": { x: '50%', y: '30%' }, "europe-west2": { x: '48%', y: '25%' },
//     "europe-west3": { x: '55%', y: '28%' }, "europe-west4": { x: '52%', y: '32%' }, "europe-west6": { x: '45%', y: '28%' },
//     "europe-central2": { x: '58%', y: '35%' }, "europe-north1": { x: '60%', y: '20%' }, "asia-east1": { x: '80%', y: '40%' },
//     "asia-east2": { x: '82%', y: '42%' }, "asia-northeast1": { x: '85%', y: '30%' }, "asia-northeast2": { x: '88%', y: '32%' },
//     "asia-northeast3": { x: '90%', y: '35%' }, "asia-south1": { x: '72%', y: '49%' }, "asia-south2": { x: '76%', y: '52%' },
//     "asia-southeast1": { x: '85%', y: '55%' }, "asia-southeast2": { x: '88%', y: '58%' }, "australia-southeast1": { x: '86%', y: '77%' },
//     "australia-southeast2": { x: '89%', y: '80%' }, "me-central1": { x: '60%', y: '45%' }, "me-west1": { x: '58%', y: '48%' },
//     "africa-south1": { x: '55%', y: '80%' },
// };

// const formatRangeValue = (value: number): string => {
//   if (value < 0) value = 0;
//   if (value >= 1000000) return `$${(value / 1000000).toFixed(1).replace('.0', '')}M`;
//   if (value >= 1000) return `$${Math.floor(value / 1000)}k`;
//   return `$${Math.round(value)}`;
// };

// const formatCurrency = (amount: string | number | null | undefined): string => {
//   if (amount === null || amount === undefined) return '$0';
//   const numericAmount = parseFloat(String(amount).replace(/[^0-9.-]+/g, ""));
//   if (isNaN(numericAmount)) return '$0';
//   return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(numericAmount);
// };

// const hexToRgba = (hex: string, alpha: number): string => {
//     if (!hex.startsWith('#')) return `rgba(232, 212, 35, ${alpha})`; // Fallback for non-hex
//     const r = parseInt(hex.slice(1, 3), 16);
//     const g = parseInt(hex.slice(3, 5), 16);
//     const b = parseInt(hex.slice(5, 7), 16);
//     return `rgba(${r}, ${g}, ${b}, ${alpha})`;
// };

// // --- MODIFICATION: New CircleMarker Component ---
// const CircleMarker = ({ color }: { color: string }) => {
//   const size = 16; // Total diameter of the outer circle
//   const innerSize = size * 0.5; // Diameter of the inner solid circle

//   return (
//     <Box sx={{
//       position: 'relative',
//       width: size,
//       height: size,
//       transform: 'translate(-50%, -50%)',
//       display: 'flex',
//       alignItems: 'center',
//       justifyContent: 'center',
//     }}>
//       {/* Outer semi-transparent circle */}
//       <Box sx={{
//         position: 'absolute',
//         width: size,
//         height: size,
//         borderRadius: '50%',
//         bgcolor: hexToRgba(color, 0.3),
//       }} />
//       {/* Inner solid circle */}
//       <Box sx={{
//         position: 'absolute',
//         width: innerSize,
//         height: innerSize,
//         borderRadius: '50%',
//         bgcolor: color,
//       }} />
//     </Box>
//   );
// };


// const CostByRegion: React.FC<CostByRegionProps> = ({ costByRegionData, isLoading }) => {
//   const theme = useTheme();
//   const [hoverInfo, setHoverInfo] = useState<HoverInfo | null>(null);
//   const cardRef = useRef<HTMLDivElement>(null);
//   const [costRanges, setCostRanges] = useState({ low: '', medium: '', high: '' });
//   const [processedRegions, setProcessedRegions] = useState<ProcessedRegion[]>([]);

//   useEffect(() => {
//     if (isLoading || !costByRegionData) {
//       setProcessedRegions([]);
//       return;
//     }
    
//     const validCosts = costByRegionData
//       .map(d => parseFloat(String(d.cost).replace(/[^0-9.-]+/g, "")))
//       .filter(c => !isNaN(c) && c >= 1)
//       .sort((a, b) => a - b);

//     if (validCosts.length === 0) {
//       setProcessedRegions([]);
//       setCostRanges({ low: '', medium: '', high: '' });
//       return;
//     }
    
//     const maxCost = validCosts[validCosts.length - 1];

//     const roundToNearest50 = (num: number) => Math.round(num / 50) * 50;
//     const boundary1 = roundToNearest50(maxCost / 3);
//     const boundary2 = roundToNearest50((2 * maxCost) / 3);
//     const niceMaxEnd = Math.ceil(maxCost / 50) * 50;
    
//     setCostRanges({
//         low: `Cost (${formatCurrency(0)} - ${formatCurrency(boundary1 - 1)})`,
//         medium: `Cost (${formatCurrency(boundary1)} - ${formatCurrency(boundary2 - 1)})`,
//         high: `Cost (${formatCurrency(boundary2)} - ${formatCurrency(niceMaxEnd)})`,
//     });

//     const tiers = { boundary1, boundary2 };

//     const getMarkerColor = (cost: number): string => {
//         if (cost >= tiers.boundary2) return '#DC2626'; // High
//         if (cost >= tiers.boundary1) return '#E8D423'; // Medium
//         return '#16A34A'; // Low
//     };
    
//     const regionsWithCost = costByRegionData
//         .map(d => ({ ...d, costNum: parseFloat(String(d.cost).replace(/[^0-9.-]+/g, ""))}))
//         .filter(d => !isNaN(d.costNum) && d.costNum >= 1);

//     const sortedForLayout = regionsWithCost
//         .map(d => ({ ...d, pos: regionToPositionMap[d.region] || { x: '50%', y: '50%' } }))
//         .sort((a,b) => parseFloat(a.pos.x) - parseFloat(b.pos.x));

//     let lastX = -100;
//     let lastY = -100;
//     let currentOffset = 0;

//     const finalRegions: ProcessedRegion[] = sortedForLayout.map(region => {
//       const xPos = parseFloat(region.pos.x);
//       const yPos = parseFloat(region.pos.y);

//       if (Math.abs(xPos - lastX) < 5 && Math.abs(yPos - lastY) < 8) {
//         currentOffset += 40; 
//       } else {
//         currentOffset = 0; 
//       }
//       lastX = xPos;
//       lastY = yPos;
      
//       return {
//           ...region,
//           labelOffset: currentOffset,
//           color: getMarkerColor(region.costNum),
//       };
//     });
//     setProcessedRegions(finalRegions);

//   }, [costByRegionData, isLoading]);


//   if (isLoading) {
//     return ( <Card elevation={0} sx={{ backgroundColor: theme.palette.background.paper, borderRadius: '10px', p: { xs: 2, sm: 3, md: 4 }, width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px' }}> <CircularProgress /> </Card> );
//   }

//   const handleMouseEnter = (e: React.MouseEvent, region: any) => {
//     const cardBox = cardRef.current?.getBoundingClientRect();
//     if (!cardBox) return;
//     setHoverInfo({ data: region, position: { top: e.clientY - cardBox.top, left: e.clientX - cardBox.left } });
//   };
//   const handleMouseLeave = () => setHoverInfo(null);


// return (
//     <Card ref={cardRef} elevation={0} sx={{ position: 'relative', backgroundColor: theme.palette.background.paper, borderRadius: '16px', p: { xs: 2, sm: 3, md: 4 }, width: '100%' }}>
//       <CardContent sx={{ p: 0, '&:last-child': { pb: 0 } }}>
//         <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
//           <Typography variant="h6" component="h2" sx={{ fontWeight: 600, fontSize: '16px' }}>Cost By Region</Typography>
//           <Stack direction="row" spacing={2} alignItems="center">
//             {costRanges.low && <Stack direction="row" alignItems="center" spacing={1}><Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: '#16A34A' }} /><Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.75rem' }}>{costRanges.low}</Typography></Stack>}
//             {costRanges.medium && <Stack direction="row" alignItems="center" spacing={1}><Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: '#E8D423' }} /><Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.75rem' }}>{costRanges.medium}</Typography></Stack>}
//             {costRanges.high && <Stack direction="row" alignItems="center" spacing={1}><Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: '#DC2626' }} /><Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.75rem' }}>{costRanges.high}</Typography></Stack>}
//           </Stack>
//         </Box>
//         <Box sx={{ 
//           position: 'relative', 
//           width: '100%', 
//           aspectRatio: '860 / 490',
//           backgroundColor: '#FFFFFF', 
//           borderRadius: '8px', 
//           backgroundImage: `url(/world_map.svg)`, 
//           backgroundSize: 'contain', 
//           backgroundPosition: 'center', 
//           backgroundRepeat: 'no-repeat',
//           mx: 'auto'
//         }}>
//           {processedRegions.map((region, i) => (
//             <Box
//               key={`${region.region}-${i}`}
//               onMouseEnter={(e) => handleMouseEnter(e, region)}
//               onMouseLeave={handleMouseLeave}
//               sx={{
//                 position: 'absolute',
//                 top: region.pos.y,
//                 left: region.pos.x,
//                 width: '1px',
//                 height: '1px',
//                 cursor: 'pointer',
//                 zIndex: region.labelOffset > 0 ? 10 : 5, 
//               }}
//             >
//               {/* --- MODIFICATION: Adjusted label position --- */}
//               <Box
//                 sx={{
//                   position: 'absolute',
//                   bottom: `${8 + 20 + region.labelOffset}px`, // Adjusted for circle size
//                   left: '50%',
//                   transform: 'translateX(-50%)',
//                   bgcolor: 'rgba(255, 255, 255, 0.9)',
//                   backdropFilter: 'blur(2px)',
//                   p: '4px 8px',
//                   borderRadius: '6px',
//                   boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
//                 }}
//               >
//                 <Typography sx={{ fontFamily: 'Inter', fontSize: '12px', fontWeight: 'bold', color: 'text.primary', whiteSpace: 'nowrap' }}>
//                   {formatCurrency(region.costNum)}
//                 </Typography>
//               </Box>
              
//               {/* --- MODIFICATION: Adjusted line position and height --- */}
//               <Box
//                 sx={{
//                   position: 'absolute',
//                   bottom: '8px', // Adjusted for circle radius
//                   left: '50%',
//                   transform: 'translateX(-50%)',
//                   width: '1.5px',
//                   height: `${20 + region.labelOffset}px`, // Adjusted height
//                   bgcolor: hexToRgba(region.color, 0.6),
//                 }}
//               />

//               {/* --- MODIFICATION: Using the new CircleMarker --- */}
//               <Box sx={{position: 'absolute', top: 0, left: 0}}>
//                  <CircleMarker color={region.color} />
//               </Box>
//             </Box>
//           ))}
//         </Box>
//       </CardContent>
//       {hoverInfo && (
//         <Box sx={{ position: 'absolute', top: hoverInfo.position.top, left: hoverInfo.position.left, transform: 'translate(15px, 15px)', minWidth: '180px', bgcolor: 'background.paper', borderRadius: '8px', p: 2, border: `1px solid ${theme.palette.divider}`, boxShadow: theme.shadows[4], pointerEvents: 'none', zIndex: 20 }}>
//           <Typography variant="body2" sx={{ fontWeight: 'bold', mb: 1, color: 'text.secondary' }}>{hoverInfo.data.region}</Typography>
//           <Divider sx={{ mb: 1 }} />
//           <Box display="flex" justifyContent="space-between" mb={0.5}>
//             <Typography variant="body2" color="text.secondary">Total Cost</Typography>
//             <Typography variant="body2" sx={{ fontWeight: 'bold' }}>{formatCurrency(hoverInfo.data.costNum)}</Typography>
//           </Box>
//         </Box>
//       )}
//     </Card>
//   );
// };
// export default CostByRegion;


import React, { useState, useRef, useEffect } from 'react';
import { Box, Typography, Card, CardContent, useTheme, Stack, Divider, CircularProgress } from '@mui/material';

// --- Interfaces and Helper Functions ---
interface RegionDetail {
  cost: string | number;
  region: string;
}

interface CostByRegionProps {
  costByRegionData?: RegionDetail[] | null;
  isLoading: boolean;
}

interface HoverInfo {
  data: any;
  position: { top: number; left: number };
}

// A new, simpler interface for the data points we'll render
interface ProcessedRegion {
  costNum: number;
  region: string;
  pos: { x: string; y: string };
  color: string;
  labelOffset: number; 
}

// Maps region names to their pixel coordinates on the map
const regionToPositionMap: { [key: string]: { x: string; y: string } } = {
    "us-central1": { x: '24%', y: '35%' }, "us-east1": { x: '28%', y: '25%' }, "us-east4": { x: '33%', y: '20%' },
    "us-west1": { x: '13%', y: '38%' }, "us-west2": { x: '12%', y: '42%' }, "us-west3": { x: '18%', y: '45%' },
    "us-west4": { x: '15%', y: '48%' }, "northamerica-northeast1": { x: '40%', y: '20%' }, "northamerica-northeast2": { x: '42%', y: '15%' },
    "southamerica-east1": { x: '40%', y: '75%' }, "europe-west1": { x: '50%', y: '30%' }, "europe-west2": { x: '48%', y: '25%' },
    "europe-west3": { x: '55%', y: '28%' }, "europe-west4": { x: '52%', y: '32%' }, "europe-west6": { x: '45%', y: '28%' },
    "europe-central2": { x: '58%', y: '35%' }, "europe-north1": { x: '60%', y: '20%' }, "asia-east1": { x: '80%', y: '40%' },
    "asia-east2": { x: '82%', y: '42%' }, "asia-northeast1": { x: '85%', y: '30%' }, "asia-northeast2": { x: '88%', y: '32%' },
    "asia-northeast3": { x: '90%', y: '35%' }, "asia-south1": { x: '72%', y: '49%' }, "asia-south2": { x: '76%', y: '52%' },
    "asia-southeast1": { x: '85%', y: '55%' }, "asia-southeast2": { x: '88%', y: '58%' }, "australia-southeast1": { x: '86%', y: '77%' },
    "australia-southeast2": { x: '89%', y: '80%' }, "me-central1": { x: '60%', y: '45%' }, "me-west1": { x: '58%', y: '48%' },
    "africa-south1": { x: '55%', y: '80%' },
};

const formatCurrency = (amount: string | number | null | undefined): string => {
  if (amount === null || amount === undefined) return '$0';
  const numericAmount = parseFloat(String(amount).replace(/[^0-9.-]+/g, ""));
  if (isNaN(numericAmount)) return '$0';
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(numericAmount);
};

const hexToRgba = (hex: string, alpha: number): string => {
    if (!hex.startsWith('#')) return `rgba(232, 212, 35, ${alpha})`; // Fallback for non-hex
    const r = parseInt(hex.slice(1, 3), 16);
    const g = parseInt(hex.slice(3, 5), 16);
    const b = parseInt(hex.slice(5, 7), 16);
    return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

const CircleMarker = ({ color }: { color: string }) => {
  const size = 16;
  const innerSize = size * 0.5;

  return (
    <Box sx={{ position: 'relative', width: size, height: size, transform: 'translate(-50%, -50%)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Box sx={{ position: 'absolute', width: size, height: size, borderRadius: '50%', bgcolor: hexToRgba(color, 0.3) }} />
      <Box sx={{ position: 'absolute', width: innerSize, height: innerSize, borderRadius: '50%', bgcolor: color }} />
    </Box>
  );
};


const CostByRegion: React.FC<CostByRegionProps> = ({ costByRegionData, isLoading }) => {
  const theme = useTheme();
  const [hoverInfo, setHoverInfo] = useState<HoverInfo | null>(null);
  const cardRef = useRef<HTMLDivElement>(null);
  const tooltipRef = useRef<HTMLDivElement>(null); // --- MODIFICATION: Ref for the tooltip
  const [costRanges, setCostRanges] = useState({ low: '', medium: '', high: '' });
  const [processedRegions, setProcessedRegions] = useState<ProcessedRegion[]>([]);
  
  // --- MODIFICATION: State to hold the calculated tooltip style ---
  const [tooltipStyle, setTooltipStyle] = useState<React.CSSProperties>({
    visibility: 'hidden',
    position: 'absolute',
    pointerEvents: 'none',
    zIndex: 20,
  });

  useEffect(() => {
    if (isLoading || !costByRegionData) {
      setProcessedRegions([]);
      return;
    }
    
    const validCosts = costByRegionData
      .map(d => parseFloat(String(d.cost).replace(/[^0-9.-]+/g, "")))
      .filter(c => !isNaN(c) && c >= 1)
      .sort((a, b) => a - b);

    if (validCosts.length === 0) {
      setProcessedRegions([]);
      setCostRanges({ low: '', medium: '', high: '' });
      return;
    }
    
    const maxCost = validCosts[validCosts.length - 1];
    const roundToNearest50 = (num: number) => Math.round(num / 50) * 50;
    const boundary1 = roundToNearest50(maxCost / 3);
    const boundary2 = roundToNearest50((2 * maxCost) / 3);
    const niceMaxEnd = Math.ceil(maxCost / 50) * 50;
    
    setCostRanges({
        low: `Cost (${formatCurrency(0)} - ${formatCurrency(boundary1 - 1)})`,
        medium: `Cost (${formatCurrency(boundary1)} - ${formatCurrency(boundary2 - 1)})`,
        high: `Cost (${formatCurrency(boundary2)} - ${formatCurrency(niceMaxEnd)})`,
    });

    const tiers = { boundary1, boundary2 };
    const getMarkerColor = (cost: number): string => {
        if (cost >= tiers.boundary2) return '#DC2626';
        if (cost >= tiers.boundary1) return '#E8D423';
        return '#16A34A';
    };
    
    const regionsWithCost = costByRegionData
        .map(d => ({ ...d, costNum: parseFloat(String(d.cost).replace(/[^0-9.-]+/g, ""))}))
        .filter(d => !isNaN(d.costNum) && d.costNum >= 1);

    const sortedForLayout = regionsWithCost
        .map(d => ({ ...d, pos: regionToPositionMap[d.region] || { x: '50%', y: '50%' } }))
        .sort((a,b) => parseFloat(a.pos.x) - parseFloat(b.pos.x));

    let lastX = -100;
    let lastY = -100;
    let currentOffset = 0;

    const finalRegions: ProcessedRegion[] = sortedForLayout.map(region => {
      const xPos = parseFloat(region.pos.x);
      const yPos = parseFloat(region.pos.y);
      if (Math.abs(xPos - lastX) < 5 && Math.abs(yPos - lastY) < 8) {
        currentOffset += 40; 
      } else {
        currentOffset = 0; 
      }
      lastX = xPos;
      lastY = yPos;
      return { ...region, labelOffset: currentOffset, color: getMarkerColor(region.costNum) };
    });
    setProcessedRegions(finalRegions);
  }, [costByRegionData, isLoading]);

  // --- MODIFICATION: useEffect to calculate tooltip position ---
  useEffect(() => {
    if (hoverInfo && tooltipRef.current && cardRef.current) {
      const cardRect = cardRef.current.getBoundingClientRect();
      const tooltipRect = tooltipRef.current.getBoundingClientRect();
      const { top: mouseY, left: mouseX } = hoverInfo.position;
      const offset = 20; // The gap between cursor and tooltip

      // Calculate position relative to the card's top-left corner
      const topRelativeToCard = mouseY - cardRect.top;
      const leftRelativeToCard = mouseX - cardRect.left;

      // Default position is bottom-right of cursor
      let finalTop = topRelativeToCard + offset;
      let finalLeft = leftRelativeToCard + offset;

      // If it overflows right, move it to the left of the cursor
      if (finalLeft + tooltipRect.width > cardRect.width - offset) {
        finalLeft = leftRelativeToCard - tooltipRect.width - offset;
      }
      
      // If it overflows bottom, move it above the cursor
      if (finalTop + tooltipRect.height > cardRect.height - offset) {
        finalTop = topRelativeToCard - tooltipRect.height - offset;
      }

      // Clamp to card boundaries to be safe
      if (finalLeft < offset) finalLeft = offset;
      if (finalTop < offset) finalTop = offset;

      setTooltipStyle(prev => ({
        ...prev,
        visibility: 'visible',
        top: `${finalTop}px`,
        left: `${finalLeft}px`,
      }));
    } else {
      // Hide tooltip when not hovering
      setTooltipStyle(prev => ({ ...prev, visibility: 'hidden' }));
    }
  }, [hoverInfo]);

  if (isLoading) {
    return ( <Card elevation={0} sx={{ backgroundColor: theme.palette.background.paper, borderRadius: '10px', p: { xs: 2, sm: 3, md: 4 }, width: '100%', display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '400px' }}> <CircularProgress /> </Card> );
  }

  // --- MODIFICATION: Store raw clientX/Y for accurate calculations ---
  const handleMouseEnter = (e: React.MouseEvent, region: any) => {
    setHoverInfo({ data: region, position: { top: e.clientY, left: e.clientX } });
  };
  const handleMouseLeave = () => setHoverInfo(null);

  return (
    <Card ref={cardRef} elevation={0} sx={{ position: 'relative', backgroundColor: theme.palette.background.paper, borderRadius: '16px', p: { xs: 2, sm: 3, md: 4 }, width: '100%', overflow: 'hidden' }}>
      <CardContent sx={{ p: 0, '&:last-child': { pb: 0 } }}>
        <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'space-between', alignItems: 'center', mb: 3 }}>
          <Typography variant="h6" component="h2" sx={{ fontWeight: 600, fontSize: '16px' }}>Cost By Region</Typography>
          <Stack direction="row" spacing={2} alignItems="center">
            {costRanges.low && <Stack direction="row" alignItems="center" spacing={1}><Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: '#16A34A' }} /><Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.75rem' }}>{costRanges.low}</Typography></Stack>}
            {costRanges.medium && <Stack direction="row" alignItems="center" spacing={1}><Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: '#E8D423' }} /><Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.75rem' }}>{costRanges.medium}</Typography></Stack>}
            {costRanges.high && <Stack direction="row" alignItems="center" spacing={1}><Box sx={{ width: 8, height: 8, borderRadius: '50%', bgcolor: '#DC2626' }} /><Typography variant="body2" color="text.secondary" sx={{ fontSize: '0.75rem' }}>{costRanges.high}</Typography></Stack>}
          </Stack>
        </Box>
        <Box sx={{ position: 'relative', width: '100%', aspectRatio: '860 / 490', backgroundColor: '#FFFFFF', borderRadius: '8px', backgroundImage: `url(/world_map.svg)`, backgroundSize: 'contain', backgroundPosition: 'center', backgroundRepeat: 'no-repeat', mx: 'auto' }}>
          {processedRegions.map((region, i) => (
            <Box key={`${region.region}-${i}`} onMouseEnter={(e) => handleMouseEnter(e, region)} onMouseLeave={handleMouseLeave} sx={{ position: 'absolute', top: region.pos.y, left: region.pos.x, width: '1px', height: '1px', cursor: 'pointer', zIndex: region.labelOffset > 0 ? 10 : 5 }}>
              <Box sx={{ position: 'absolute', bottom: `${8 + 20 + region.labelOffset}px`, left: '50%', transform: 'translateX(-50%)', bgcolor: 'rgba(255, 255, 255, 0.9)', backdropFilter: 'blur(2px)', p: '4px 8px', borderRadius: '6px', boxShadow: '0 2px 8px rgba(0,0,0,0.1)' }}>
                <Typography sx={{ fontFamily: 'Inter', fontSize: '12px', fontWeight: 'bold', color: 'text.primary', whiteSpace: 'nowrap' }}>{formatCurrency(region.costNum)}</Typography>
              </Box>
              <Box sx={{ position: 'absolute', bottom: '8px', left: '50%', transform: 'translateX(-50%)', width: '1.5px', height: `${20 + region.labelOffset}px`, bgcolor: hexToRgba(region.color, 0.6) }}/>
              <Box sx={{position: 'absolute', top: 0, left: 0}}>
                 <CircleMarker color={region.color} />
              </Box>
            </Box>
          ))}
        </Box>
      </CardContent>
      
      {/* --- MODIFICATION: Tooltip now uses the ref and dynamic style state --- */}
      <Box ref={tooltipRef} sx={{ ...tooltipStyle, minWidth: '180px', bgcolor: 'background.paper', borderRadius: '8px', p: 2, border: `1px solid ${theme.palette.divider}`, boxShadow: theme.shadows[4] }}>
        {hoverInfo && (
          <>
            <Typography variant="body2" sx={{ fontWeight: 'bold', mb: 1, color: 'text.secondary' }}>{hoverInfo.data.region}</Typography>
            <Divider sx={{ mb: 1 }} />
            <Box display="flex" justifyContent="space-between" mb={0.5}>
              <Typography variant="body2" color="text.secondary">Total Cost</Typography>
              <Typography variant="body2" sx={{ fontWeight: 'bold' }}>{formatCurrency(hoverInfo.data.costNum)}</Typography>
            </Box>
          </>
        )}
      </Box>
    </Card>
  );
};
export default CostByRegion;
